import type { SxProps, Theme } from '@mui/material';

import { IllustrationWrapper } from '../IllustrationWrapper';

import { HouseSearchingIllustration } from './HouseSearching';

interface Props {
  readonly sx?: SxProps<Theme>;
  readonly title?: string;
}

export const HouseSearching = ({ sx, title }: Readonly<Props>) => (
  <IllustrationWrapper sx={sx}>
    <HouseSearchingIllustration title={title} />
  </IllustrationWrapper>
);
